import { render, staticRenderFns } from "./FlightInformations.vue?vue&type=template&id=2b53335a&scoped=true"
import script from "./FlightInformations.vue?vue&type=script&lang=js"
export * from "./FlightInformations.vue?vue&type=script&lang=js"
import style0 from "./FlightInformations.vue?vue&type=style&index=0&id=2b53335a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53335a",
  null
  
)

export default component.exports